'use strict';

angular.module('app.home.subscribeNow.subscribeNowController', [
])
    .controller('app.home.subscribeNow.subscribeNowController', [
        '$scope',
        function ($scope) {
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/home/subscribeNow/subscribeNowController.js